import { lazy } from 'react';

const frontendUpgradesModuleConfig = {
  id: 'frontend-upgrades',
  name: 'Frontend Upgrades',
  icon: '🔄',
  color: 'teal',
  description: 'Track and manage frontend code upgrades across tenant sites',
  version: '1.0.0',
  enabled: true,
  category: 'development',
  order: 100,
  routes: [
    {
      path: '/frontend-upgrades',
      component: lazy(() => import('./UpgradesList')),
      exact: true,
      permissions: ['FRONTEND_UPGRADES_ADMIN', 'ADMIN']
    },
    {
      path: '/frontend-upgrades/new',
      component: lazy(() => import('./NewUpgrade')),
      permissions: ['FRONTEND_UPGRADES_ADMIN', 'ADMIN']
    },
    {
      path: '/frontend-upgrades/help',
      component: lazy(() => import('./ModuleSummary')),
      permissions: ['FRONTEND_UPGRADES_ADMIN', 'ADMIN']
    },
    {
      path: '/frontend-upgrades/:id',
      component: lazy(() => import('./UpgradeDetail')),
      permissions: ['FRONTEND_UPGRADES_ADMIN', 'ADMIN']
    },
    {
      path: '/frontend-upgrades/:id/edit',
      component: lazy(() => import('./EditUpgrade')),
      permissions: ['FRONTEND_UPGRADES_ADMIN', 'ADMIN']
    }
  ],
  navigation: [
    {
      label: 'All Upgrades',
      path: '/frontend-upgrades',
      icon: '📋',
      permissions: ['FRONTEND_UPGRADES_ADMIN', 'ADMIN']
    },
    {
      label: 'New Upgrade',
      path: '/frontend-upgrades/new',
      icon: '➕',
      permissions: ['FRONTEND_UPGRADES_ADMIN', 'ADMIN']
    },
    {
      label: 'Module Help',
      path: '/frontend-upgrades/help',
      icon: '📖',
      permissions: ['FRONTEND_UPGRADES_ADMIN', 'ADMIN']
    }
  ],
  permissions: {
    view: ['FRONTEND_UPGRADES_ADMIN', 'ADMIN'],
    create: ['FRONTEND_UPGRADES_ADMIN', 'ADMIN'],
    edit: ['FRONTEND_UPGRADES_ADMIN', 'ADMIN'],
    delete: ['FRONTEND_UPGRADES_ADMIN', 'ADMIN']
  },
  quickActions: [
    {
      label: 'Track New Upgrade',
      path: '/frontend-upgrades/new',
      icon: '➕',
      description: 'Register a new frontend upgrade',
      permissions: ['FRONTEND_UPGRADES_ADMIN', 'ADMIN']
    }
  ],

    // 📝 CHANGELOG
    changelog: [
        {
            version: "1.0.0",
            releaseDate: "2025-11-22",
            title: "Stable Release - Production Ready",
            features: [
                "✅ Production-ready upgrade tracking system",
                "✅ Comprehensive upgrade documentation",
                "✅ Multi-tenant deployment tracking",
                "✅ Code change version control",
                "✅ Rollback and deployment history",
                "✅ Module-specific upgrade tracking"
            ],
            notes: "Official stable release with enterprise-grade deployment tracking."
        },
        {
            version: "0.3.0",
            releaseDate: "2025-11-02",
            title: "Enhanced Editing & Detail Views",
            features: [
                "✨ Enhanced EditUpgrade component (409 lines)",
                "✨ Improved UpgradeDetail functionality (42 lines)",
                "✨ Better upgrade modification workflow",
                "✨ Enhanced validation and error handling"
            ],
            notes: "Edit and detail view improvements for better upgrade management."
        },
        {
            version: "0.2.0",
            releaseDate: "2025-03-15",
            title: "UI Enhancements & User Experience",
            features: [
                "✨ Enhanced upgrade list filtering",
                "✨ Improved search functionality",
                "✨ Better status indicators",
                "✨ Enhanced mobile responsiveness",
                "✨ Improved upgrade timeline visualization"
            ],
            notes: "UI/UX improvements for better upgrade tracking experience."
        },
        {
            version: "0.1.0",
            releaseDate: "2024-10-24",
            title: "Initial Frontend Upgrades System",
            features: [
                "✅ Created UpgradesList component (321 lines)",
                "✅ Created NewUpgrade component (360 lines)",
                "✅ Created UpgradeDetail component (452 lines)",
                "✅ Created ModuleSummary component (432 lines)",
                "✅ Created EditUpgrade component (24 lines)",
                "✅ Module configuration and routing (78 lines)",
                "✅ Upgrade creation and tracking",
                "✅ Deployment history logging",
                "✅ Role-based permissions (FRONTEND_UPGRADES_ADMIN)"
            ],
            notes: "Initial implementation with 1,667 lines of upgrade tracking code."
        }
    ],

    // 🗺️ ROADMAP
    roadmap: []

};

export default frontendUpgradesModuleConfig;
